<app-breadcrumb [master]="'Narzędzia'" [parentName]="'Formularze'" [name]="'Lista'"></app-breadcrumb>

  <div class="tags-list-container" >

    <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="tags-list-filters">
      <mat-form-field class="tags-list-filter">
        <mat-label> Nazwa formularza</mat-label>
        <input matInput placeholder=" Nazwa formularza" name="contains$name" [(ngModel)]="initialFilters.contains$name">
      </mat-form-field>

      <mat-form-field appearance="standard" class="tags-list-filter">
        <mat-label>Wysyłka maili</mat-label>
        <mat-select [(ngModel)]="initialFilters.emailSend" name="emailSend">
          <mat-option [value]="null">Wszyscy</mat-option>
          <mat-option [value]="1">Tak</mat-option>
          <mat-option [value]="0">Nie</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="standard" class="tags-list-filter">
        <mat-label>Aktywny</mat-label>
        <mat-select [(ngModel)]="initialFilters.active" name="active">
          <mat-option [value]="null">Wszyscy</mat-option>
          <mat-option [value]="1">Tak</mat-option>
          <mat-option [value]="0">Nie</mat-option>
        </mat-select>
      </mat-form-field>


      <app-datepicker
        class="tags-list-filter"
        label="Data dodania od"
        placeholder="2000-01-01"
        [required]="false"
        [(ngModel)]="initialFilters.gte$createdAt" name="gte$createdAt"
      ></app-datepicker>

      <app-datepicker
        class="tags-list-filter"
        label="Data dodania do"
        placeholder="2000-01-01"
        [required]="false"
        [(ngModel)]="initialFilters.lte$createdAt" name="lte$createdAt"
      ></app-datepicker>

      <mat-form-field appearance="standard" class="tags-list-filter">
        <input matInput placeholder="Wyszukiwarka"
               [(ngModel)]="initialFilters.finder" name="finder" >
      </mat-form-field>

    </form>

    <div class="tags-list-buttons">

      <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
      <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
    </div>

    <div class="test">
          <button *ngIf="(userPermissions | async).form.admin_root " [disabled]="!(userPermissions | async).form.admin_root " mat-stroked-button color="accent" [routerLink]="['/formularze/dodaj']"><mat-icon>add</mat-icon> <span> Dodaj formularz </span></button>
    </div>


  <table mat-table [dataSource]="dataSource">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> Nazwa formularza </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/formularze/szczegoly', element.uuid]">{{element.name}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="link">
      <th mat-header-cell *matHeaderCellDef> Link do formularza </th>
      <td mat-cell *matCellDef="let element">
        {{element.linkToForm}}
      </td>
    </ng-container>

    <ng-container matColumnDef="emailSend">
      <th mat-header-cell *matHeaderCellDef> Wysyłka maili </th>
      <td mat-cell *matCellDef="let element">
        <button *ngIf="element.emailSend" mat-icon-button><mat-icon class="positive-icon">check_circle</mat-icon></button>
        <button *ngIf="!element.emailSend" mat-icon-button><mat-icon class="negative-icon">cancel</mat-icon></button>
      </td>
    </ng-container>
    <ng-container matColumnDef="active">
      <th mat-header-cell *matHeaderCellDef> Aktywny </th>
      <td mat-cell *matCellDef="let element">
        <button *ngIf="element.active" mat-icon-button><mat-icon class="positive-icon">check_circle</mat-icon></button>
        <button *ngIf="!element.active" mat-icon-button><mat-icon class="negative-icon">cancel</mat-icon></button>
      </td>
    </ng-container>
    <ng-container matColumnDef="emailAddressList">
      <th mat-header-cell *matHeaderCellDef > Lista adresów </th>
      <td mat-cell *matCellDef="let element">
        <div *ngFor="let email of element.emailAddressList">
          {{ email }}
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef> Data utworzenia </th>
      <td mat-cell *matCellDef="let element">
     {{element.createdAt | date:'y-MM-dd H:mm'}}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
    <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
  </div>
